


















































































































































































































































































































































import Vue from "vue"
import {officeService} from "@/model/service/office/office-service"
import { employeeService } from "@/model/service/employee/employee-service"
import OfficeRangeTable from "@/components/office-range-table/OfficeRangeTable.vue"
import store from "@/vuex/store"
import moment from "moment"
import qz from "qz-tray"

const ZPL_TYPES = ["ZPL", "ZPL_300"]

export default Vue.extend({
  components: {OfficeRangeTable},
  data() {
    return {
      format: "",
      officeService: officeService,
      employeeService: employeeService,
      loading: false,
      printerConfigurationVisible: false,
      parcelnumberRangesVisible: false,
      ranges: [],
      versionAndRelease: null,
      changelogsVisible: false,
      page: 1,
      size: 6,
      startPosition: -1,
      printingMethod: "MANUAL",
      printer: "",
      printerList: []
    }
  },
  methods: {
    isZplFormat(format: string) {
      return ZPL_TYPES.includes(format)
    },
    executeQz(call: () => void) {
      const vm = this
      if (qz.websocket.isActive()) {
        call()
      } else {
        qz.websocket
          .connect()
          .then(call)
          .catch((e: any) => vm.$error(vm.$t("qz.error")))
      }
    },
    getDate(date: any) {
      return moment(new Date(date)).format("DD.MM.YYYY")
    },
    downloadFile(path: string, newTab: boolean) {
      let url = process.env.VUE_APP_ROOT + path
      if (url.startsWith("//")) {
          url = url.substring(1, url.length)
      }
      if (newTab) {
        window.open(url)
      } else {
        const link = document.createElement("a") as any
        link.setAttribute("href", url)
        link.setAttribute("download", url.split("/").pop())
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    getRanges() {
      const vm = this
      this.$http.get("/range_office/by_office/" + vm.$store.getters.loggedUser.office.id).then(response => {
        vm.ranges = response.data
      })
    },
    savePrinterConfiguration() {
      const vm = this
      this.loading = true
      this.$store.state.authenticatedEmployee.office.reportPageFormat = this.format
      this.$store.state.authenticatedEmployee.office.reportPageStartPosition = this.startPosition
      this.$store.state.authenticatedEmployee.office.printer = this.printer
      this.$store.state.authenticatedEmployee.office.printingMethod = this.printingMethod
      this.officeService
        .modify(this.$store.state.authenticatedEmployee.office)
        .then(() => {
          vm.loading = false
          vm.printerConfigurationVisible = false
          vm.$message({
            message: this.$t("header.routes.printer_configuration.updated").toString(),
            type: "success",
            duration: 3000
          })
        })
        .catch(() => (vm.loading = false))
    },
    updatePrinterConfiguration() {
      const vm = this
      const savedFormat = vm.$store.state.authenticatedEmployee.office.reportPageFormat
      vm.format = savedFormat === "ZPL_203" ? "ZPL" : savedFormat
      vm.startPosition = vm.$store.state.authenticatedEmployee.office.reportPageStartPosition
    },
    timeCalculatorClick() {
      const currentCountry = store.state.easyshipConfiguration.domesticCountry.countryIso
      if (currentCountry === "HR") {
         this.$i18n.locale === "hr"
         ? window.location.href = "https://www.dpd.com/hr/hr/kalkulator-vremena-dostave/"
         : window.location.href = "https://www.dpd.com/hr/en/lead-time-calculator/"
      } else {
          this.$i18n.locale === "si"
          ? window.location.href = "https://www.dpd.com/si/sl/kalkulator-za-izracun-dobavnega-roka/"
          : window.location.href = "https://www.dpd.com/si/en/lead-time-calculator/"
      }
    },
    findPickupLocation() {
      const currentCountry = store.state.easyshipConfiguration.domesticCountry.countryIso
      if (currentCountry === "HR") {
          window.location.href = "https://www.dpdgroup.com/hr/mydpd/parcel-shops"
      } else {
          window.location.href = "https://www.dpdgroup.com/si/mydpd/parcel-shops"
      }
    }
  },
  computed: {
    releases(): any {
      return (this.versionAndRelease! as any).releases!
        .slice((this.page - 1) * this.size, this.page * this.size)
    }
  },
  watch: {
    printingMethod: {
      handler() {
        if (this.isZplFormat(this.format) && this.printingMethod === "MIDDLEWARE") {
          const vm = this
          this.executeQz(() =>
            qz.printers
              .find()
              .then((found: any) => (vm.printerList = found))
              .catch((e: any) => vm.$error(vm.$t("qz.error")))
          )
        }
      }
    }
  },
  created() {
    const vm = this
    const savedFormat = vm.$store.state.authenticatedEmployee.office.reportPageFormat
    vm.format = savedFormat === "ZPL_203" ? "ZPL" : savedFormat
    vm.startPosition = vm.$store.state.authenticatedEmployee.office.reportPageStartPosition
    vm.$http.get("/version/version_and_release").then(response => {
      vm.versionAndRelease = response.data
    })
    vm.printingMethod = vm.$store.state.authenticatedEmployee.office.printingMethod
    vm.printer = vm.$store.state.authenticatedEmployee.office.printer
  }
})
